// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const ropeCoil = defineModel({
  id: "rope-coil",
  batchId: "future",
  name: "Rope coil",
  tags: ["scenery","rope","coil","low-poly","age-of-mcp","future"],
  summary: "Coils of rope — rigging, hauling, wells, scaffolds and nets.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.36,
  parts: () => [
      { geometry: new THREE.TorusGeometry(0.22, 0.05, 6, 14), color: "#b89a5e", position: [0, 0.055, 0], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.TorusGeometry(0.2, 0.045, 6, 14), color: "#a98c52", position: [0.01, 0.13, 0.01], rotation: [1.570796, 0.2, 0] },
      { geometry: new THREE.TorusGeometry(0.17, 0.04, 6, 14), color: "#c7a868", position: [-0.01, 0.2, 0], rotation: [1.570796, -0.2, 0] },
      { geometry: new THREE.CylinderGeometry(0.022, 0.022, 0.16, 6), color: "#a98c52", position: [0.24, 0.08, 0.06], rotation: [0.3, 0, 0.4] },
    ],
  animations: [],
});
